import { Table } from 'react-bootstrap';

export default function Orcamento() {
    return <div className="table-responsive">
        <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Relatórios de Atividades</small></p>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>ANO</th>
                    <th>RELATÓRIOS <br /> DE ATIVIDADES</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>2025</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="http://www.alepe.pe.gov.br/downloads/orcamento2025/ITEM-21-RELATORIO-DE-DESEMPENHO-DA-GESTAO-2025.pdf" title="Download em PDF"> Visualizar em PDF</a></td>
                </tr>
                <tr>
                    <td>2024</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="http://www.alepe.pe.gov.br/downloads/orcamento2024/ITEM-21-RELATORIO-DE-DESEMPENHO-DA-GESTAO-2024.pdf" title="Download em PDF"> Visualizar em PDF</a></td>
                </tr>                
                <tr>
                    <td>2023</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="http://www.alepe.pe.gov.br/downloads/orcamento2023/relatorio-circunstanciado.pdf" title="Download em PDF"> Visualizar em PDF</a></td>
                </tr>
                <tr>
                    <td>2022</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="https://www.alepe.pe.gov.br/downloads/orcamento2023/2022-ITEM-23-RELATORIO-DE-DESEMPENHO-DA-GESTAO.pdf" title="Download em PDF"> Visualizar em PDF</a> </td>
                </tr>
                <tr>
                    <td>2021</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="https://www.alepe.pe.gov.br/wp-content/uploads/2022/12/2021 - relatorio.pdf" title="Download em PDF"> Visualizar em PDF</a> </td>
                </tr>
                <tr>
                    <td>2020</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="https://www.alepe.pe.gov.br/wp-content/uploads/2022/12/2020 - relatorio.pdf" title="Download em PDF"> Visualizar em PDF</a> </td>
                </tr>
                <tr>
                    <td>2019</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="https://www.alepe.pe.gov.br/wp-content/uploads/2022/12/2019 - relatorio.pdf" title="Download em PDF"> Visualizar em PDF</a> </td>
                </tr>
                <tr>
                    <td>2018</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="https://www.alepe.pe.gov.br/wp-content/uploads/2022/12/2018 - relatorio.pdf" title="Download em PDF"> Visualizar em PDF</a> </td>
                </tr>
                <tr>
                    <td>2017</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="https://www.alepe.pe.gov.br/wp-content/uploads/2022/12/2017 - relatorio.pdf" title="Download em PDF"> Visualizar em PDF</a> </td>
                </tr>

                <tr>
                    <td>2016</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="https://www.alepe.pe.gov.br/wp-content/uploads/2022/12/2016 - relatorio.pdf" title="Download em PDF"> Visualizar em PDF</a> </td>
                </tr>
                <tr>
                    <td>2015</td>
                    <td> <a target="_blank" rel="noopener noreferrer" href="https://www.alepe.pe.gov.br/wp-content/uploads/2022/12/2015 - relatorio.pdf" title="Download em PDF"> Visualizar em PDF</a> </td>
                </tr>
            </tbody>
        </Table>
    </div>
}